// import { INSTANCE as UserInfoManager } from '@/core/userInfo/UserInfoManager'
// import { OWORK_WEB_EVENT_GROUP, TrackConfig } from '@core/TrackConstants'
// import { useOTrack } from '@oplus/obus-track-vue'

export interface TrackParam {
  eventId: string
  eventGroup?: string
}

// const oTrack = useOTrack(TrackConfig)

export const useOtrack = () => {
  const track = async <T extends { [key: string]: unknown }>(trackInfo: TrackParam, trackProperties?: T) => {
    // const userInfo = await UserInfoManager.getUserInfo()
    // const uid = userInfo?.ssoId
    // if (uid) {
    //   oTrack?.setUserId(uid)
    // }
    // oTrack?.track({
    //   properties: {
    //     uid,
    //     ...(trackProperties ?? {}),
    //   },
    //   eventGroup: OWORK_WEB_EVENT_GROUP,
    //   ...trackInfo,
    // })
  }

  return {
    track,
  }
}
